import React, { useRef, useEffect, useCallback } from 'react';
import 'aframe';
import '../primitives/hotspot';

import AframeIcon from '../components/AframeIcon';
import AframeTitle from '../components/AframeTitle';
import { hotspotTypes } from '../hotspotConstants';

const StopHotspot = ({
  active,
  changeStop,
  darkMode,
  hidden,
  hideGlow,
  hotspotId,
  icon,
  iconSize,
  iconSrc,
  isBeingEdited,
  isDisabled,
  position,
  rotation,
  showLabel,
  stopId,
  stopNum,
  title,
  tourId,
  tourName,
  value,
  ariaLabel,
  cameraPosition,
  primaryColor,
  hotspotLabelTheme,
}) => {
  const scene = document.getElementById('scene');
  const titleId = showLabel ? `title_${hotspotId}` : null;
  const iconId = `icon_${hotspotId}`;
  const srcId = '#hotspot__up-arrow-icon';
  const iconRef = useRef();
  const customAssetId = `custom-asset_${hotspotId}`;
  const customIconId = `custom-icon_${hotspotId}`;
  const focusId = `focus-outline_${hotspotId}`;
  const useCustomIcon = icon && iconSrc;

  const handleOpen = useCallback((e) => {
    const { type, stopId, stopNum } = e.detail || {};
    if (type === hotspotTypes.STOP && typeof changeStop === 'function') {
      changeStop({ stopId, stopNum });
    }
  }, [changeStop]);

  useEffect(() => {
    if (scene) {
      scene.addEventListener('hotspot-open', handleOpen);
      return () => {
        scene.removeEventListener('hotspot-open', handleOpen);
      };
    }
  }, [handleOpen, scene]);

  return (
    <a-entity rotation={rotation}>
      <a-hotspot
        darkmode={darkMode}
        underedits={isBeingEdited}
        disabled={isDisabled}
        visible={!hidden}
        position={position}
        icon={useCustomIcon ? customIconId : iconId}
        hotspottitle={titleId}
        id={`hotspot_${hotspotId}`}
        active={active}
        tourId={tourId}
        tourName={tourName}
        hotspotName={title}
        type="stop"
        data-testid={`hotspot_${hotspotId}`}
        data-cy={`hotspot_${hotspotId}`}
        focusoutlineicon={focusId}
        role="link"
        tabIndex={0}
        aria-label={ariaLabel}
        hotspotid={hotspotId}
        rotateto={cameraPosition}
        stopid={stopId}
        stopnum={stopNum || value}
      >
        {showLabel && (
          <AframeTitle
            id={titleId}
            data-testid={titleId}
            title={title}
            darkMode={darkMode}
            iconSize={iconSize}
            hotspotLabelTheme={hotspotLabelTheme}
            primaryColor={primaryColor}
          />
        )}
        <AframeIcon
          focusId={focusId}
          src={
            icon ? `#${customAssetId}` : `${srcId}${darkMode ? '-black' : ''}`
          }
          id={icon ? customIconId : iconId}
          forwardRef={iconRef}
          hideGlow={hideGlow}
          iconSize={iconSize}
          data-testid={icon ? customIconId : iconId}
        />
        {useCustomIcon && (
          <a-asset>
            <img
              src={iconSrc}
              id={customAssetId}
              data-testid={customAssetId}
              crossOrigin="anonymous"
              alt=""
            />
          </a-asset>
        )}
      </a-hotspot>
    </a-entity>
  );
};

export default StopHotspot;
